( ( $ ) => {
	$( () => {
		$( '.form-control[data-dependent]' ).each( ( i, droplist ) => {
			const $droplist = $(droplist),
				$form = $droplist.closest( 'form' ),
				dependentFieldName = $droplist.attr( 'data-dependent' ).trim(),
				$dependentField = $form.find( '.control-label' ).filter( ( i, c ) => ( $( c ).text() || '' ).trim() === dependentFieldName ).next( '.form-control' ),
				options = $droplist.find( 'option' ).get();
			function update() {
				for( const option of options ) {
					const $option = $( option ),
						condition = ( $option.attr( 'data-condition' ) || '' ).trim(),
						value = String( $dependentField.val() || '' ).trim(),
						isMatch = !condition || ( condition === value );
					if( isMatch ) {
						$droplist.append( $option );
					} else {
						$option.prop( 'selected', false );
						$option.detach();
					}
				}
			}
			$form.on( 'click focus blur change keyup keydown', '.form-control', () => {
				update();
			} );
			update();
		} );
	} );
} )( jQuery );
